import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Form, Modal, Row } from 'antd';
import { queryAccountRoleAccounts } from '@api/core/role';

import SearchUser from '@comm/SearchUser';

const FormItem = Form.Item;

class IndexModal extends Component {
  constructor(props) {
    super(props);
    this.state = { accountUuids: [] };
  }

  componentWillMount() {
    this.loadData(this.props.roleUuid);
  }

  componentWillReceiveProps(nextProps) {
    this.props.roleUuid !== nextProps.roleUuid && this.loadData(nextProps.roleUuid);
  }

  submit = () => {
    const { form } = this.props;
    form.validateFields((err, values) => {
      if (!err) {
        this.props.onOk(values.accountUuids, () => form.resetFields());
      }
    });
  };

  onCancel = () => {
    this.props.onCancel();
  };

  loadData = roleUuid => {
    roleUuid &&
      queryAccountRoleAccounts({ roleUuid }).then(res => {
        if (res.statusCode === 200) {
          const accountUuids = res.data.map(item => {
            return item.uuid;
          });
          this.setState(
            {
              accountUuids,
            },
            () => this.props.form.setFieldsValue({ accountUuids }),
          );
        }
      });
  };

  onChangeProcessor = value => {
    this.setState({ accountUuids: value });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { accountUuids } = this.state;
    const ItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };
    return (
      <Modal
        title="角色用户授权"
        visible={this.props.visible}
        onOk={this.submit}
        onCancel={this.onCancel}
      >
        <Form>
          <Row>
            <Col span={20}>
              <FormItem label="关联用户" {...ItemLayout}>
                {getFieldDecorator('accountUuids', {
                  rules: [{ required: true, message: '关联用户!' }],
                  initialValue: accountUuids || [],
                })(
                  <SearchUser
                    isMultiple="multiple"
                    onChange={(value, options) => {
                      this.onChangeProcessor(value, options);
                    }}
                  />,
                )}
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  }
}

export default connect(state => ({
  accountInfo: state.account_info,
}))(Form.create()(IndexModal));



// WEBPACK FOOTER //
// ./src/components/boss/role/ModalRoleUsercAdd.js